import { clone } from '@jack-henry/frontend-utils/functions';
import { AccountModelDto, StopPaymentProductFeatureModelDto } from '@treasury/api/bo';
import { CompanyProductFeature } from './company-product-feature.entity';

const defaultDto: StopPaymentProductFeatureModelDto = {
    type: 'StopPayment',
    approvalCount: 0,
    id: 0,
    productUniqueId: '',
    isConfigurable: true,
};

export class StopPaymentProductFeature extends CompanyProductFeature<StopPaymentProductFeatureModelDto> {
    constructor(dto: StopPaymentProductFeatureModelDto = clone(defaultDto)) {
        super(dto);
    }

    public createDefault(): this {
        throw new Error('Method not implemented.');
    }

    public get accounts() {
        return this.dto.accounts ?? [];
    }

    public set accounts(value: AccountModelDto[]) {
        this.dto.accounts = value;
    }

    public get approvalCount() {
        return this.dto.approvalCount;
    }

    public set approvalCount(value: number) {
        this.dto.approvalCount = value;
    }
}
